import sortByString, { sortByCode } from '../helpers/helpers';
import Filter from '../common/Filter';

export default {};

export const defaultFilters = {
  active: [1],
  categoryIds: [1, 2, 3, 4],
};

export const getDefaultFilters = (categoriesMap) => {
  const newFilters = {
    active: [1],
    categoryIds: [],
  };

  Object.values(categoriesMap || {})?.forEach((category) => {
    newFilters.categoryIds.push(category.id);
  });

  return newFilters;
};

export const getFilterData = (categoriesMap) => {
  const filterData = [
    [
      {
        title: 'Archive',
        key: 'active',
        children: [
          {
            title: 'Active',
            key: 1,
          },
          {
            title: 'Archived',
            key: 0,
          },
        ],
      },
    ],
  ];

  const categoriesFilterData = {
    title: 'Categories',
    key: 'categoryIds',
    children: [],
  };

  Object.values(categoriesMap || {})?.forEach((category) => {
    categoriesFilterData.children.push({
      title: category.name,
      key: category.id,
    });
  });

  filterData.push(categoriesFilterData);

  return filterData;
};

const getIdxFromField = (field, value) => field?.toLowerCase()?.indexOf(value);

export const searchCostcodes = (costcode, searchTerm) => {
  const nameLen = costcode.name.length;
  const codeLen = costcode.code.length;
  if (searchTerm.match(/^[0-9]+$/)) {
    const codeIdx = getIdxFromField(costcode.code, searchTerm);
    if (codeIdx >= 0) return codeIdx;
    const nameIdx = getIdxFromField(costcode.name, searchTerm);
    if (nameIdx >= 0) return nameIdx + codeLen;
    const descIdx = getIdxFromField(costcode.description, searchTerm);
    return descIdx >= 0 ? descIdx + nameLen + codeLen : -1;
  }
  const nameIdx = getIdxFromField(costcode.name, searchTerm);
  if (nameIdx >= 0) return nameIdx;
  const codeIdx = getIdxFromField(costcode.code, searchTerm);
  if (codeIdx >= 0) return codeIdx + nameLen;
  const descIdx = getIdxFromField(costcode.description, searchTerm);
  return descIdx >= 0 ? descIdx + nameLen + codeLen : -1;
};

export const searchTieBreaker = (searchTerm, a, b) => (
  sortByString(searchTerm.match(/^[0-9]+$/) ? 'code' : 'name')(a, b)
);

export const SORT_OPTIONS = [
  { title: 'Code: Ascending', icon: 'sort-ascending' },
  { title: 'Code: Descending', icon: 'sort-descending' },
  { title: 'Name: A to Z', icon: 'sort-ascending' },
  { title: 'Name: Z to A', icon: 'sort-descending' },
];

export const createCostcodeFilter = () => new Filter({
  data: [],
  defaultFilters,
});

export const applyCostcodeSort = ({
  sortOptions,
  fetchedCodes,
  filter,
  ascending,
  sortType,
  storageKeyText,
  storageKeyActive,
}) => {
  const sortFn = sortType === 'name' ? sortByString('name') : sortByCode('code');
  let titleIdx = ascending ? 0 : 1;
  if (sortType === 'name') {
    titleIdx = ascending ? 2 : 3;
  }
  const sortTitle = sortOptions[titleIdx].title;
  const currentSort = [sortType, ascending];
  // eslint-disable-next-line no-param-reassign
  filter.data = [...fetchedCodes].sort((a, b) => (ascending ? 1 : -1) * sortFn(a, b));
  window.localStorage.setItem(storageKeyText, sortTitle);
  window.localStorage.setItem(storageKeyActive, JSON.stringify(currentSort));
  return { sortTitle, currentSort };
};
